import React, { useMemo } from 'react';
import './Returns.scss';
import ProFormaReturnsTable from 'components/ProFormaReturnsTable/ProFormaReturnsTable';
import { useProFormaSocketContext } from '../../ProForma/socketContext/ProFormaSocketProvider';
import { getPeriodKeys, transformReturnsData } from './helpers';

const Returns = () => {
    const {
        returnsData, operatingInfo, showCents, periodCadence,
    } = useProFormaSocketContext();

    const transformedData = useMemo(() => transformReturnsData(returnsData, periodCadence), [returnsData, periodCadence]);
    const dateKeys = useMemo(() => getPeriodKeys(returnsData, periodCadence), [returnsData, periodCadence]);

    return (
        <div className="Returns">
            {transformedData && (
                <ProFormaReturnsTable
                    showCents={showCents}
                    propertyReturns={transformedData}
                    dateKeys={dateKeys}
                    operationBeginMonth={operatingInfo.operationBeginMonth || 0}
                    cadence={periodCadence}
                />
            )}
        </div>
    );
};

export default Returns;
